export default __webpack_public_path__ + "static/soehne-mono-buch-a9e37adf05dc9bfeb774893d7ba1d56f.woff2";